// extracted by mini-css-extract-plugin
module.exports = {"heading":"Summary_heading__--ko6","summary":"Summary_summary__1Xf1R","value":"Summary_value__2lE0J"};